var pug = require("!../../../../../node_modules/pug-runtime/index.js");

function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (artwork) {
buf.push("<div class=\"embedded-inquiry-success\"><p><strong>Inquiry Sent</strong></p><p>You will receive an email receipt of your inquiry shortly.\nIf you want to follow up with the " + (jade.escape((jade_interp = artwork.related().partner.displayType().toLowerCase()) == null ? '' : jade_interp)) + ", simply reply to this email.</p></div>");}.call(this,"artwork" in locals_for_with?locals_for_with.artwork:typeof artwork!=="undefined"?artwork:undefined));;return buf.join("");
};
module.exports = template;